const router = {
  props(route) {
    const { name, params, query } = route

    if (query.adjuster && query.adjuster === 'true') {
      params.adjuster = true
    }

    if (!params.routeName) {
      params.routeName = name
    }

    return {
      ...params,
      query,
    }
  },
}

export default router
